import React from 'react';
import './BotBlocked.css';

const BotBlocked = ({ botName }) => {
  return (
    <div className="bot-blocked-container">
      <div className="bot-blocked-content">
        <div className="bot-blocked-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="120"
            height="120"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
            <circle cx="12" cy="16" r="1"></circle>
            <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
          </svg>
        </div>
        <h1 className="bot-blocked-title">Access Restricted</h1>
        <p className="bot-blocked-message">
          Automated bots and crawlers are not permitted to access this website.
        </p>
        {botName && (
          <div className="bot-blocked-bot-name">
            <strong>Detected:</strong> {botName}
          </div>
        )}
        <div className="bot-blocked-footer">
          <p>If you believe this is an error, please contact support.</p>
        </div>
      </div>
    </div>
  );
};

export default BotBlocked;

